import { generateNumberMask } from 'components/modules/Insurance/Insurance.helpers';
import { VALUE_FIELDS } from 'store/carInstance/constants';

export const ENGINE_POWER_MASK = generateNumberMask({ max: 10 ** 4, postfix: 'л.с.' });

export const NAME = VALUE_FIELDS.ENGINE_POWER;
